import { render, staticRenderFns } from "./DescricaoNivelLinha.vue?vue&type=template&id=0b72dc28&scoped=true"
import script from "./DescricaoNivelLinha.vue?vue&type=script&lang=js"
export * from "./DescricaoNivelLinha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b72dc28",
  null
  
)

export default component.exports